import { render, staticRenderFns } from "./card-sona.vue?vue&type=template&id=6f1bdabb&scoped=true&"
import script from "./card-sona.vue?vue&type=script&lang=js&"
export * from "./card-sona.vue?vue&type=script&lang=js&"
import style0 from "./card-sona.vue?vue&type=style&index=0&id=6f1bdabb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1bdabb",
  null
  
)

export default component.exports